import {
  formatLineTracking,
  IContact,
  ICreditNote,
  IInvoiceChildField,
  StatusEnum,
} from "shared";

// TEMP
export interface UILineItem {
  id?: string;
  description: string;
  quantity: number;
  amount: string;
  total: string;
  taxAmount?: string;
  accountCode?: string;
  /** Xero tracking for this line, formatted e.g. "Region: North" (empty when none) */
  tracking?: string;
}

// TEMP UNTIL WE DO INVOICE API
export interface InvoiceDetails {
  number: string;
  reference: string;
  status: StatusEnum;
  contact: IContact;
  dueDateString: string;
  issueDateString: string;
  /** YYYY-MM-DD, set once fully paid */
  dateFullyPaid?: string;
  organisationTimezone: string;
  lineItems: UILineItem[];
  subTotal: string;
  total: string;
  tax: string;
  discounts: string;
  paidAmount: string;
  /** Set when the invoice has a deposit (QBO); already included in paidAmount */
  depositAmount?: string;
  dueAmount: string;
  externalLink?: string;
  frozen: boolean;
  deleted: boolean;
  createdByUs: boolean;
  creditNotes: ICreditNote[];
  groupTitle?: string;
  sent_to_customer?: boolean;
  currency: string;
  hash: string;
  expectedPaymentDate?: string;
  childFields: IInvoiceChildField[];
  invoiceEmail?: string | null;
  invoiceEmailCc?: string | null;
  invoiceEmailBcc?: string | null;
  processingStripePayments: [{
    stripePaymentId: number;
    amountCents: number;
    currency: string;
    readable: string;
  }];
}

export function parseLineItems(invoice, formatter): UILineItem[] {
  if (!invoice || !invoice.xero_line_items?.lineItems) return [];

  if (invoice.xero_line_items?.lineItems) {
    return invoice.xero_line_items.lineItems.map(item => {
      return {
        id: item.lineItemID,
        description: item.description,
        quantity: item.quantity,
        // Portal strips values the org hides, so render those blank
        amount: item.unitAmount === undefined ? `` : formatter(item.unitAmount),
        total: item.lineAmount === undefined ? `` : formatter(item.lineAmount),
        taxAmount: item.taxAmount ? formatter(item.taxAmount) : undefined,
        accountCode: item.accountCode,
        tracking: formatLineTracking(item.tracking),
      };
    });
  }
}
